<mat-expansion-panel class="card-panel" [expanded]="true" hideToggle>
  <mat-expansion-panel-header>
    <mat-panel-title>
      <i class="material-icons" (click)="downloadImage($event)">
        save
      </i>   {{('dashboard.' + name) | translate}}
    </mat-panel-title>
    <mat-panel-description>

    </mat-panel-description>
  </mat-expansion-panel-header>
  <div class="panel-content" #screen>

    @if (type === 'double-pie') {
      <div>
        @if (systemTyp) {
          <mat-slide-toggle
            matTooltip="nur zukünftige Events berücksichtig"
            [hidden]="!showDownload"
            style="float: right"
            class="example-margin"
            [(ngModel)]="isTime"
            (change)="changeTime()">
            <i class="material-icons">
              today
            </i>
          </mat-slide-toggle>
        }
        <div >
          <div class="pie-double-info">
            @if (data[0].length) {
              <ngx-charts-pie-chart
                class="chart-container"
                [view]="view"
                [scheme]="'solar'"
                [results]="data[0]"
                [labels]="true"
                [doughnut]="false"
                [explodeSlices]="false"
                [trimLabels]="false"
                [animations]="animations">
              </ngx-charts-pie-chart>
            }
            @if (!data[0].length) {
              <p class="no-data-msg-chart-small">No Data</p>
            }
          </div>
          <div class="pie-double-info">
            @if (data[1].length) {
              <ngx-charts-pie-chart
                class="chart-container"
                [view]="view"
                [scheme]="'aqua'"
                [results]="data[1]"
                [labels]="true"
                [doughnut]="false"
                [explodeSlices]="false"
                [trimLabels]="false"
                [animations]="animations">
              </ngx-charts-pie-chart>
            }
            @if (!data[1].length) {
              <p class="no-data-msg-chart-small">No Data</p>
            }
          </div>
          <div class="pie-double-info">
            @if (data[2].length) {
              <ngx-charts-pie-chart
                class="chart-container"
                [view]="view"
                [scheme]="'air'"
                [results]="data[2]"
                [labels]="true"
                [doughnut]="false"
                [trimLabels]="false"
                [explodeSlices]="false"
                [animations]="animations">
              </ngx-charts-pie-chart>
            }
            @if (!data[2].length) {
              <p class="no-data-msg-chart-small">No Data</p>
            }
          </div>
          <div class="pie-double-info">
            @if (data[3].length) {
              <ngx-charts-pie-chart
                class="chart-container"
                [view]="view"
                [scheme]="'nightLights'"
                [results]="data[3]"
                [labels]="true"
                [doughnut]="false"
                [trimLabels]="false"
                [explodeSlices]="false"
                [animations]="animations">
              </ngx-charts-pie-chart>
            }
            @if (!data[3].length) {
              <p class="no-data-msg-chart-small">No Data</p>
            }
          </div>
        </div>
      </div>
    }

    @if (type === 'pie-grid') {
      <div>
        <mat-slide-toggle
          [hidden]="!showDownload"
          style="float: right"
          class="example-margin"
          [(ngModel)]="checked">
          <i class="material-icons">
            blur_linear
          </i>
        </mat-slide-toggle>
        @if (systemTyp) {
          <mat-slide-toggle
            matTooltip="nur zukünftige Events berücksichtig"
            [hidden]="!showDownload"
            style="float: right"
            class="example-margin"
            [(ngModel)]="isTime"
            (change)="changeTime()">
            <i class="material-icons">
              today
            </i>
          </mat-slide-toggle>
        }
        @if (checked  && data) {
          <div class="pie-grid-info" [ngStyle]="{height: ((data.length / 4) * 200) + 'px'}" >
            @if (data.length) {
              <ngx-charts-pie-grid
                class="chart-container"
                [view]="view"
                [scheme]="colorScheme ? colorScheme : 'ocean'"
                [customColors]="colorScheme"
                [results]="data"
                [animations]="animations">
              </ngx-charts-pie-grid>
            }
            @if (!data.length) {
              <p class="no-data-msg-chart">No Data</p>
            }
          </div>
        }
        @if (!checked && data) {
          <div class="pie-grid-info pie" >
            @if (data.length) {
              <ngx-charts-pie-chart
                class="chart-container"
                [view]="view"
                [scheme]="colorScheme ? colorScheme : 'ocean'"
                [customColors]="colorScheme"
                [results]="data"
                [trimLabels]="false"
                [labels]="true"
                [doughnut]="false"
                [explodeSlices]="false"
                [animations]="animations">
              </ngx-charts-pie-chart>
            }
            @if (!data.length) {
              <p class="no-data-msg-chart">No Data</p>
            }
          </div>
        }
      </div>
    }

  </div>
</mat-expansion-panel>


<div [hidden]="true" id="download">
  <img #canvas>
  <a #downloadLink></a>
</div>

